import { render } from "./SiteApp.vue?vue&type=template&id=49d5e5da&scoped=true"
import script from "./SiteApp.vue?vue&type=script&lang=js"
export * from "./SiteApp.vue?vue&type=script&lang=js"

import "./SiteApp.vue?vue&type=style&index=0&id=49d5e5da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/kama-dugri/kama-dugri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d5e5da"]])

export default __exports__